/** Words the shared primitives in src/components/ui say on their own. */
export const ui = {
  confirm: 'Confirm',
  copyCode: 'copy',
  showSidebar: 'Show sidebar',
  doopHome: 'Doop home',
  setUpManually: 'Set up manually',
  selectedOf: '{count} of {total} selected',
} as const
